import useProjectManagementStore from "../store/useProjectManagementStore.js"
import useProjectManagementHook from "../hooks/useProjectManagementHook";
import ProjectPopup from "../components/ProjectPopup.js"
const ProjectManagementFilter = () => {
  const {isModalOpen,setIsModalOpen}=useProjectManagementStore();
  const {handler}=useProjectManagementHook();
  const handleProjectPopup=()=>{
    handler.handleResetAddPopup();
    setIsModalOpen(true)
  }
 
  return (
   <>
      <div class="page-header-title">
          <h5 class="m-b-10">Project Management</h5>
          <div>
                <button className='btn btn-primary btn-sm' onClick={handleProjectPopup}><i className="fa fa-plus"></i> New project</button>
          </div>
        </div>
         <ProjectPopup isModalOpen={isModalOpen}  handleCloseModal={() => setIsModalOpen(false)}  />
   </>
  );
};

export default ProjectManagementFilter;
